import strings from '../locales/ring.json'
import type { RingReason } from './ring-api'

// R503 (c): the till ring's labels, one locale file in the till's pair pattern ({ ar, en } per
// key, as in-flight.json), with HOP's ring key names so Rook's Arabic for the HOP ring section
// can be carried key by key. R537: RingPanel draws the pair's one language under the till's switch.

export type Lang = 'en' | 'ar'

export type RingLabelKey = keyof typeof strings

export interface RingPair {
  en: string
  ar: string
}

export const REASON_LABEL: Record<RingReason, RingLabelKey> = {
  pending: 'reasonPending',
  held_card: 'reasonHeldCard',
  kitchen_not_started: 'reasonKitchenNotStarted',
  final_check_not_started: 'reasonFinalCheckNotStarted',
}

/** A label with its `{slot}`s filled, in both languages; a slot may carry a value per language. */
export function ringLabel(key: RingLabelKey, slots?: Record<string, string | RingPair>): RingPair {
  const pair = strings[key]
  const fill = (s: string, lang: Lang) =>
    slots
      ? s.replace(/\{(\w+)\}/g, (m, k: string) => {
          if (!(k in slots)) return m
          const v = slots[k]
          return typeof v === 'string' ? v : v[lang]
        })
      : s
  return { en: fill(pair.en, 'en'), ar: fill(pair.ar, 'ar') }
}
